import { render, staticRenderFns } from "./DeleteReportAction.vue?vue&type=template&id=4356f86f&"
import script from "./DeleteReportAction.vue?vue&type=script&lang=js&"
export * from "./DeleteReportAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports